export default __webpack_public_path__ + "static/media/ic_memos-to-watch.e7d81f86.svg";